import { BuildFeatureItemId } from "components/BuildFeatures/BuildFeatures.types";
import { TVideoCardFeatureV2 } from "pages/LayoutComponents/VideoCardGrid/VideoCardGrid.types";
import wanSwitchMp4 from "../assets/related-addons/wan-switch.mp4";
import wanSwitchPosterJpg from "../assets/related-addons/wan-switch-poster.jpg";
import wanSwitchPreviewPng from "../assets/related-addons/wan-switch-preview.png";
import toollessMiniRackMp4 from "../../../../assets/related-addons/shared/toolless-mini-rack.mp4";
import toollessMiniRackJpg from "../../../../assets/related-addons/shared/toolless-mini-rack.jpg";
import toollessMiniRackPreviewPng from "../assets/related-addons/toolless-mini-rack-preview.png";
import lteBackupProMp4 from "../../../../assets/related-addons/shared/lte-backup-pro.mp4";
import lteBackupProJpg from "../../../../assets/related-addons/shared/lte-backup-pro.jpg";
import lteBackupProPreviewPng from "../assets/related-addons/lte-backup-pro-preview.png";
import powerBackupMp4 from "../../../../assets/related-addons/shared/power-backup.mp4";
import powerBackupPreviewJpg from "../../../../assets/related-addons/shared/power-backup-preview.jpg";
import powerBackupPreviewPng from "../assets/related-addons/power-backup-preview.png";
import powerDistributionProMp4 from "../../../../assets/related-addons/shared/power-distribution-pro.mp4";
import powerDistributionProJpg from "../../../../assets/related-addons/shared/power-distribution-pro.jpg";
import powerDistributionProPreviewPng from "../assets/related-addons/power-distribution-pro-preview.png";
import enterpriseHddMp4 from "../../../../assets/related-addons/shared/enterprise-hdd.mp4";
import enterpriseHddJpg from "../../../../assets/related-addons/shared/enterprise-hdd.jpg";
import hddStoragePreviewPng from "../assets/related-addons/hdd-storage-preview.png";
import rackMountOcdPanelsMp4 from "../../../../assets/related-addons/shared/rack-mount-ocd-panels.mp4";
import rackMountOcdPanelsJpg from "../../../../assets/related-addons/shared/rack-mount-ocd-panels.jpg";
import rackMountOcdPanelsPreviewPng from "../assets/related-addons/rack-mount-ocd-panels-preview.png";
import floatingMount12cmMp4 from "../../../../assets/related-addons/cloud-gateways/floating-mount-12cm.mp4";
import floatingMount12cmJpg from "../../../../assets/related-addons/cloud-gateways/floating-mount-12cm.jpg";
import floatingMount17cmMp4 from "../../../../assets/related-addons/cloud-gateways/floating-mount-17cm.mp4";
import floatingMount17cmJpg from "../../../../assets/related-addons/cloud-gateways/floating-mount-17cm.jpg";
import floatingMountPreviewPng from "../assets/related-addons/floating-mount-preview.png";
import universalTableStandMp4 from "../../../../assets/related-addons/shared/universal-table-stand.mp4";
import universalTableStandJpg from "../../../../assets/related-addons/shared/universal-table-stand.jpg";
import universalTableStandPreviewPng from "../assets/related-addons/universal-table-stand-preview.png";
import poeIntegratedAdapterMp4 from "../../../../assets/related-addons/shared/poe-integrated-adapter.mp4";
import poeIntegratedAdapterJpg from "../../../../assets/related-addons/shared/poe-integrated-adapter.jpg";
import poeIntegratedAcAdapterPreviewPng from "../assets/related-addons/poe-integrated-ac-adapter-preview.png";
import powerDistributionHiDensityMp4 from "../../../../assets/related-addons/shared/power-distribution-hi-density.mp4";
import powerDistributionHiDensityJpg from "../../../../assets/related-addons/shared/power-distribution-hi-density.jpg";
import powerDistributionHiDensityPreviewPng from "../assets/related-addons/power-distribution-hi-density-preview.png";
import blankKeystonePatchPanelMp4 from "../../../../assets/related-addons/shared/_24-port-blank-keystone-patch-panel.mp4";
import blankKeystonePatchPanelPosterJpg from "../../../../assets/related-addons/shared/_24-port-blank-keystone-patch-panel-poster.jpg";
import blankKeystonePatchPanelPreviewPng from "../assets/related-addons/24-port-blank-keystone-patch-panel-preview.png";
import m2SsdTrayMp4 from "../../../../assets/related-addons/cloud-gateways/m2-ssd-tray.mp4";
import m2SsdTrayJpg from "../../../../assets/related-addons/cloud-gateways/m2-ssd-tray.jpg";
import m2SsdTrayPreviewPng from "../assets/related-addons/m2-ssd-tray-preview.png";
import microSdCard128gbMp4 from "../../../../assets/related-addons/shared/micro-sd-card-128gb.mp4";
import microSdCard128gbJpg from "../../../../assets/related-addons/shared/micro-sd-card-128gb.jpg";
import microSdCardPreviewPng from "../assets/related-addons/micro-sd-card-preview.png";

export const INSTALLATION_ADDONS = [
  {
    id: "WanSwitching",
    title: "installationAddons.wanSwitching.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        label: "installationAddons.wanSwitching.wan.dimension.label",
        dimensionsMillimeters: "442.4 x 120 x 43.7 mm",
        dimensionsInches: '(17.4 x 4.72 x 1.7")',
      },
      {
        label: "installationAddons.wanSwitching.rJ45.dimension.label",
        dimensionsMillimeters: "442.4 x 120 x 43.7 mm",
        dimensionsInches: '(17.4 x 4.72 x 1.7")',
      },
    ],
    description: "installationAddons.wanSwitching.description",
    video: {
      src: wanSwitchMp4,
      poster: wanSwitchPosterJpg,
    },
    uiComLink: {
      href: "/switching/wan",
      label: "installationAddons.viewWanSwitch.label",
    },
    previewImg: wanSwitchPreviewPng,
  },
  {
    id: "ToollessMiniRack",
    title: "installationAddons.toollessMiniRack.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        label:
          "installationAddons.toollessMiniRack.handleAndCaster.dimensions.label",
        dimensionsMillimeters: "519 x 460 x 485 mm",
        dimensionsInches: '(20.43 x 18.11 x 19.09")',
      },
      {
        label: "installationAddons.toollessMiniRack.withOut.dimensions.label",
        dimensionsMillimeters: "519 x 460 x 351 mm",
        dimensionsInches: '(20.43 x 18.11 x 13.82")',
      },
    ],
    description: "installationAddons.toollessMiniRack.description",
    video: {
      src: toollessMiniRackMp4,
      poster: toollessMiniRackJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/toolless-mini-rack`,
    },
    previewImg: toollessMiniRackPreviewPng,
  },
  {
    id: "LTEBackupPro",
    title: "installationAddons.lteBackupPro.title",
    description: "installationAddons.lteBackupPro.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "66 x 202 x 32 mm",
        dimensionsInches: '(2.6 x 8 x 1.3")',
      },
    ],
    video: {
      src: lteBackupProMp4,
      poster: lteBackupProJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/u-lte-backup-pro`,
    },
    previewImg: lteBackupProPreviewPng,
  },
  {
    id: "PowerBackup",
    title: "installationAddons.powerBackup.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    description: "installationAddons.powerBackup.description",
    dimensions: [
      {
        dimensionsMillimeters: "442.4 x 325.6 x 43.7 mm",
        dimensionsInches: '(17.4 x 12.8 x 1.7")',
      },
    ],
    video: {
      src: powerBackupMp4,
      poster: powerBackupPreviewJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-rps`,
    },
    previewImg: powerBackupPreviewPng,
  },
  {
    id: "PowerDistributionPro",
    title: "installationAddons.powerDistributionPro.title",
    description: "installationAddons.powerDistributionPro.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "442.4 x 87.4 x 106 mm",
        dimensionsInches: '(17.4 x 3.4 x 4.2")',
      },
    ],
    video: {
      src: powerDistributionProMp4,
      poster: powerDistributionProJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-pdu-pro`,
    },
    previewImg: powerDistributionProPreviewPng,
  },
  {
    id: "EnterpriseHDD",
    title: "installationAddons.enterpriseHdd.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "147 x 101.9 x 26.1 mm",
        dimensionsInches: '(5.75 x 4 x 1")',
      },
    ],
    description: "installationAddons.enterpriseHdd.description",
    video: {
      src: enterpriseHddMp4,
      poster: enterpriseHddJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories`,
      searchParams: {
        subcategory: "accessories-storage",
      },
    },
    previewImg: hddStoragePreviewPng,
  },
  {
    id: "RackMountOCDPanels",
    title: "installationAddons.rackMountOcdPanels.title",
    description: "installationAddons.rackMountOcdPanels.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    video: {
      src: rackMountOcdPanelsMp4,
      poster: rackMountOcdPanelsJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-rack-panel-ocd`,
    },
    previewImg: rackMountOcdPanelsPreviewPng,
  },
  {
    id: "24PortBlankKeystonePatchPanel",
    title: "installationAddons.blankKeystonePatchPanel.title",
    description: "installationAddons.blankKeystonePatchPanel.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        label:
          "installationAddons.blankKeystonePatchPanel.standAlone.dimension.label",
        dimensionsMillimeters: "442.4 x 63.5 x 43.7 mm",
        dimensionsInches: '(17.4 x 2.5 x 1.7")',
      },
      {
        label:
          "installationAddons.blankKeystonePatchPanel.management.dimension.label",
        dimensionsMillimeters: "433.8 x 71.5 x 17 mm",
        dimensionsInches: '(17.1 x 2.8 x 0.7")',
      },
    ],
    video: {
      src: blankKeystonePatchPanelMp4,
      poster: blankKeystonePatchPanelPosterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-rack-panel-patch-blank-24`,
    },
    previewImg: blankKeystonePatchPanelPreviewPng,
  },
  {
    id: "PowerDistributionHiDensity",
    title: "installationAddons.powerDistributionHiDensity.title",
    description: "installationAddons.powerDistributionHiDensity.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.EFG, label: "Enterprise Fortress Gateway" },
      { id: BuildFeatureItemId.UDMProMax, label: "UDM Pro Max" },
      { id: BuildFeatureItemId.UDMPro, label: "UDM Pro" },
      { id: BuildFeatureItemId.UDMSpecialEdition, label: "UDM SE" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "1485 x 55 x 56 mm",
        dimensionsInches: '(58.5 x 2.17 x 2.2")',
      },
    ],
    video: {
      src: powerDistributionHiDensityMp4,
      poster: powerDistributionHiDensityJpg,
    },
    learnMoreLink: {
      path: `/unifi/integrations/usp-pdu-hd`,
    },
    previewImg: powerDistributionHiDensityPreviewPng,
  },
  {
    id: "FloatingMount",
    title: "installationAddons.cgFloatingMount.title",
    description: "installationAddons.cgFloatingMount.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.UCGUltra, label: "Cloud Gateway Ultra" },
      { id: BuildFeatureItemId.UCGMax, label: "Cloud Gateway Max" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "127.7 x 113.5 x 5.1 mm",
        dimensionsInches: '(5 x 4.5 x 0.2")',
      },
    ],
    video: {
      src: floatingMount17cmMp4,
      poster: floatingMount17cmJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-fm-17cm`,
    },
    previewImg: floatingMountPreviewPng,
  },
  {
    id: "M2ssdTray",
    title: "installationAddons.m2ssdTray.title",
    description: "installationAddons.m2ssdTray.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.UCGMax, label: "Cloud Gateway Max" },
      { id: BuildFeatureItemId.UCGFiber, label: "Cloud Gateway Fiber" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "123.4 x 31.1 x 11.2 mm",
        dimensionsInches: '(4.9 x 1.2 x 0.4")',
      },
    ],
    video: {
      src: m2SsdTrayMp4,
      poster: m2SsdTrayJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-ssd-tray`,
    },
    previewImg: m2SsdTrayPreviewPng,
  },
  {
    id: "UniversalTableStand",
    title: "installationAddons.universalTableStand.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.Express7, label: "Express 7" },
      { id: BuildFeatureItemId.Express, label: "Express" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "125.2 x 73.2 x 70.5 mm",
        dimensionsInches: '(4.9 x 2.9 x 2.8")',
      },
    ],
    description: "installationAddons.universalTableStand.description",
    video: {
      src: universalTableStandMp4,
      poster: universalTableStandJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-uts`,
    },
    previewImg: universalTableStandPreviewPng,
  },
  {
    id: "PoEIntegratedAcAdapter",
    title: "installationAddons.poeIntegratedAcAdapter.title",
    description: "installationAddons.poeIntegratedAcAdapter.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.Express7, label: "Express 7" }],
    dimensions: [
      {
        dimensionsMillimeters: "46 x 62 x 42 mm",
        dimensionsInches: '(5.7 x 2.4 x 1.7")',
      },
    ],
    video: {
      src: poeIntegratedAdapterMp4,
      poster: poeIntegratedAdapterJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-poe-plus-usbc`,
    },
    previewImg: poeIntegratedAcAdapterPreviewPng,
  },
  {
    id: "FloatingMountExpress",
    title: "installationAddons.cgFloatingMountSmall.title",
    description: "installationAddons.cgFloatingMountSmall.description",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.Express, label: "UniFi Express" },
      { id: BuildFeatureItemId.GatewayLite, label: "Cloud Gateway Lite" },
    ],
    dimensions: [
      {
        dimensionsMillimeters: "83.4 x 83.4 x 4.8 mm",
        dimensionsInches: '(3.3 x 3.3 x 0.2")',
      },
    ],
    video: {
      src: floatingMount12cmMp4,
      poster: floatingMount12cmJpg,
    },
    learnMoreLink: { path: `/unifi/accessories/uacc-fm` },
    previewImg: floatingMountPreviewPng,
  },
  {
    id: "MicroSdCard",
    title: "installationAddons.microSdCard.title",
    category: "commons.installationAddOn",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.UDR7, label: "Dream Router 7" }],
    dimensions: [
      {
        dimensionsMillimeters: "15 x 11 x 1 mm",
        dimensionsInches: '(5.75 x 4 x 1")',
      },
    ],
    description: "installationAddons.microSdCard.description",
    video: {
      src: microSdCard128gbMp4,
      poster: microSdCard128gbJpg,
    },
    learnMoreLink: {
      path: `/unifi/accessories/msd`,
    },
    previewImg: microSdCardPreviewPng,
  },
] satisfies TVideoCardFeatureV2[];
